import * as yup from 'yup'
import * as linkSchemas from '../link/Link.schema'
import { createDataSchema, createDataRef } from '../schemaUtils'

export const ImageSchema = createDataSchema(
	'Image',
	yup.object({
		link: createDataRef(linkSchemas).nullable(),
		title: yup.string().default('').max(100),
		name: yup.string().max(100),
		uri: yup.string().default(''),
		description: yup.string().max(1200),
		height: yup.number().default(200),
		width: yup.number().default(200),
		borderSize: yup.string(),
		alt: yup.string().default(''),
		originalImageDataRef: yup.string().nullable().meta({ description: 'Original Image before edit' }), // TODO handle pseudoType ref with createDataRef(imageOverlaySchema).nullable()
		opacity: yup.number(),
		crop: yup
			.object({
				x: yup.number().min(0),
				y: yup.number().min(0),
				width: yup.number().min(0),
				height: yup.number().min(0),
				svgId: yup.string().meta({
					description: 'Defines an svg uri for a mask inside the crop boundaries',
				}),
				flip: yup.mixed<'x' | 'y' | 'xy' | 'none'>().oneOf(['x', 'y', 'xy', 'none']).meta({
					description: 'Defines whether the mask is flipped on the v or h axis',
				}),
				rotate: yup.number().min(0).max(360).meta({ description: 'Defines a rotation angle for the mask' }),
			})
			.notRequired()
			.default(undefined),
		upscaleMethod: yup.string().meta({
			description: 'used for upscaling method when building an image url , expected values default|super',
		}),
		focalPoint: yup
			.object({
				x: yup.number().min(0).max(100),
				y: yup.number().min(0).max(100),
			})
			.notRequired()
			.default(undefined),
		artist: yup.object({ name: yup.string(), id: yup.string() }),
	})
)
